/* eslint-env browser */
import { CSSProperties, RefObject } from 'react';

const getAnchor = (
  target: HTMLElement,
  container: RefObject<HTMLDivElement>,
  offset: number = 0,
): [string, CSSProperties] => {
  const boxWidth = container.current?.getBoundingClientRect().width || 0;
  const boxHeight = container.current?.getBoundingClientRect().height || 0;
  const rect = target.getBoundingClientRect();
  const halfHeight = window.innerHeight / 2;
  const elementY = window.pageYOffset + rect.top - offset;
  const elementX = rect.left + rect.width / 2 - boxWidth / 2;

  if (target.getBoundingClientRect().top < halfHeight) {
    const top = elementY + 30;

    if (window.innerWidth - boxWidth < elementX) {
      return ['top-right', { top, left: window.innerWidth - (boxWidth + 15) }];
    }

    if (elementX < 15) {
      return ['top-left', { top, left: 15 }];
    }

    return ['top-middle', { top, left: elementX }];
  }

  const top = elementY - boxHeight - 30;

  if (window.innerWidth - boxWidth < elementX) {
    return ['bottom-right', { top, left: window.innerWidth - (boxWidth + 15) }];
  }

  if (elementX < 15) {
    return ['bottom-left', { top, left: 15 }];
  }

  return ['bottom-middle', { top, left: elementX }];
};

export default getAnchor;
